import React, { useEffect } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import AccountSitesSelector from './Components/AccountSitesSelector';
import {
  fetchAccountSitesAsync,
  fetchSitesAsync,
  modifyAccountSitesAsync,
  selectSites,
  selectSitesForAccount,
  selectSitesLoadingStatus,
  Site,
  updateSitesForAccount,
} from './sitesSlice';
import { LOADING_STATUS } from '../../common/constants';
import { addStatusToast, Loader } from '../../common/components';
import { clearInputErrors } from '../errors/errorsSlice';

interface AccountSitesTabContainerProps {
  backLinkUrl: string;
  accountId: string;
}

const AccountSitesTabContainer: React.FunctionComponent<
  AccountSitesTabContainerProps
> = ({ backLinkUrl, accountId }) => {
  const dispatch = useAppDispatch();
  const sites = useAppSelector(selectSites);
  const sitesForAccount = useAppSelector(selectSitesForAccount);
  const sitesLoading = useAppSelector(selectSitesLoadingStatus);

  useEffect(() => {
    dispatch(fetchSitesAsync());
    dispatch(fetchAccountSitesAsync(accountId));
  }, [accountId, dispatch]);

  const handleSiteChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    site: Site,
  ) => {
    const { checked } = event.target;
    dispatch(updateSitesForAccount({ site, checked }));
  };

  const saveSelectedSites = (event: React.FormEvent) => {
    event.preventDefault();
    dispatch(
      modifyAccountSitesAsync({ accountId, selectedSites: sitesForAccount }),
    )
      .then(unwrapResult)
      .then(() => {
        dispatch(
          addStatusToast({
            Message: `Käyttäjän varaamotiedot tallennettu.`,
          }),
        );
        dispatch(clearInputErrors());
      });
  };

  return (
    <>
      <Loader IsLoading={sitesLoading === LOADING_STATUS.LOADING} />
      {sitesLoading === LOADING_STATUS.IDLE && (
        <AccountSitesSelector
          sites={sites}
          sitesForAccount={sitesForAccount}
          onSiteChange={handleSiteChange}
          backLinkUrl={backLinkUrl}
          saveSelectedSites={saveSelectedSites}
        />
      )}
    </>
  );
};

export default AccountSitesTabContainer;
